import { render } from "./Umfragen.vue?vue&type=template&id=3cf00a1b&scoped=true"
import script from "./Umfragen.vue?vue&type=script&lang=ts"
export * from "./Umfragen.vue?vue&type=script&lang=ts"

import "./Umfragen.vue?vue&type=style&index=0&id=3cf00a1b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cf00a1b"

export default script